import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PortalDailyDeliveredLogTable from './portal-daily-delivered-log-table.jsx';

if (document.getElementById('react-component-g4-logistics-portal-admin-daily-delivered-log')) {
    ReactDOM.render(<PortalDailyDeliveredLogTable/>,
    document.getElementById('react-component-g4-logistics-portal-admin-daily-delivered-log'));
}
